<template>
  <form @submit.prevent="handleSubmit" novalidate>
    <div class="form-group">
      <div class="title" style="margin-bottom: 6px;">
        <div class="tag hissu" style="padding: 2px 4px;">必須</div>
        <div class="txt">お名前</div>
      </div>
      <div class="box">
        <input
          type="text"
          v-model="form.name"
          placeholder="例：山田 太郎"
          :disabled="isLoading"
        />
        <p v-if="errors.name" class="error-text">{{ errors.name }}</p>
      </div>
    </div>

    <div class="form-group">
      <div class="title" style="margin-bottom: 6px;">
        <div class="tag hissu" style="padding: 2px 4px;">必須</div>
        <div class="txt">生まれ年</div>
      </div>
      <div class="box">
        <select v-model="form.birthyear" :disabled="isLoading">
          <option value="">選択してください</option>
          <option v-for="opt in birthYearOptions" :key="opt.value" :value="opt.value">{{ opt.label }}</option>
        </select>
        <p v-if="errors.birthyear" class="error-text">{{ errors.birthyear }}</p>
      </div>
    </div>

    <div class="slide_control_group">
      <a href="#" class="prev" @click.prevent="handleBack">＜ 戻る</a>
      <button type="submit" class="form_button" :disabled="isLoading">次へ</button>
    </div>
  </form>
</template>

<script>
import { generateBirthYearOptions } from '../../../lib/lp_gym01/validators'

export default {
  name: 'Step3Form',
  emits: ['submit', 'back'],
  props: {
    defaultValues: { type: Object, default: () => ({}) },
    isLoading: { type: Boolean, default: false }
  },
  data () {
    return {
      birthYearOptions: generateBirthYearOptions(),
      form: {
        name: this.defaultValues.name || '',
        birthyear: this.defaultValues.birthyear != null ? this.defaultValues.birthyear : ''
      },
      errors: {}
    }
  },
  methods: {
    validate () {
      this.errors = {}
      if (!this.form.name || this.form.name.trim().length === 0) {
        this.errors.name = 'お名前を入力してください'
      } else if (this.form.name.length > 80) {
        this.errors.name = 'お名前は80文字以内で入力してください'
      }
      if (!this.form.birthyear) this.errors.birthyear = '生まれ年を選択してください'
      return Object.keys(this.errors).length === 0
    },
    handleSubmit () {
      if (!this.validate()) return
      this.$emit('submit', {
        ...this.form,
        birthyear: Number(this.form.birthyear)
      })
    },
    handleBack () {
      this.$emit('back', { ...this.form })
    }
  }
}
</script>

<style scoped>
.error-text {
  margin-top: 4px;
  font-size: 12px;
  color: #ef4444;
}
</style>
